import React, { useState, useEffect } from 'react';
import {
  TabsContainer,
  TabsHeader,
  TabButton,
  TabContent,
} from './Tabs.styles';

interface Tab {
  label: string;
  content: React.ReactNode;
}

interface TabsProps {
  tabs: Tab[];
  defaultActiveTab?: number;
  selectedTab?: number;
  onTabChange?: (index: number) => void;
  disabledTabs?: number[];
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  defaultActiveTab = 0,
  selectedTab,
  onTabChange,
  disabledTabs = [],
}) => {
  const [activeTab, setActiveTab] = useState(defaultActiveTab);

  useEffect(() => {
    if (selectedTab !== undefined) {
      setActiveTab(selectedTab);
    }
  }, [selectedTab]);

  const handleTabChange = (index: number) => {
    const isDisabled = disabledTabs.includes(index);
    if (isDisabled) return;
    if (onTabChange) {
      onTabChange(index);
    } else {
      setActiveTab(index);
    }
  };

  return (
    <TabsContainer>
      <TabsHeader>
        {tabs.map((tab, index) => (
          <TabButton
            key={index}
            isActive={activeTab === index}
            onClick={() => handleTabChange(index)}
            disabled={disabledTabs.includes(index)}
          >
            {tab.label}
          </TabButton>
        ))}
      </TabsHeader>
      <TabContent>{tabs[activeTab].content}</TabContent>
    </TabsContainer>
  );
};

export default Tabs;
